import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { workRegisterKeys } from './workRegisters.key';

export function useGetInspectorStatistics(
  controlId: string,
  workRegisterId: string | undefined
) {
  const getApi = useApi();

  const getInspectorStatistics = async () => {
    if (!workRegisterId) return Promise.resolve([]);

    const api = await getApi();
    const res = await api.personnelFindInspectorStatistics(workRegisterId);

    return res.data;
  };

  return useQuery({
    queryKey: workRegisterKeys.personnelInspectorStatistics(controlId),
    queryFn: getInspectorStatistics,
  });
}
